<template>
    <div>
        <div class="col-md-12 bg-violet rounded text-white p-lg-6" style="font-size: 16px">
            <div class="col-12 p-lg-0 bg-violet mb-4 p-4 d-lg-flex">
                <div class="col-xl-3 col-lg-4 table-config custom-background text-white rounded p-4">
                    <div style="height: 200px">
                        <h2>Kết quả Kinh doanh RSM</h2>
                        <div>
                            <label>Chọn tên RSM</label>
                            <el-select clearable v-model="query.userId" filterable class="w-100"
                                       placeholder="Chọn RSM để xem" @change="getData" :disabled = "disableSelectRsm">
                                <el-option
                                    v-for="item in users"
                                    :key="item.id"
                                    :label="item.name"
                                    placeholder="Chọn RSM"
                                    :value="item.id">
                                    <span style="float: left">{{ item.name }}</span>
                                </el-option>
                            </el-select>
                        </div>
                        <div class="my-4">
                            <el-select clearable v-model="now" filterable class="w-100"
                                       placeholder="Chọn năm" @change="getData">
                                <el-option
                                    v-for="item in years"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                    <span style="float: left">{{ item }}</span>
                                </el-option>
                            </el-select>
                        </div>
                    </div>

                    <div class="rounded bg-white p-2">
                        <p>Hướng dẫn xem:</p>
                        <p><span style="font-weight: bold">1. Tại mục Tên:</span> <span>Chọn RSM tra cứu</span></p>
                        <p><span style="font-weight: bold">2. Tại mục Khu vực:</span> <span>Chọn RSM Khu vực tra cứu</span></p>
                        <p><span style="font-weight: bold">3. Tại mục Văn phòng:</span> <span>Chọn văn phòng tra cứu</span></p>
                    </div>
                    <div class=" rounded bg-white text-dark p-2 mt-4"  style="height: 246px">
                        <table class="table-report w-100">
                            <thead>
                                <tr>
                                    <th>Số khu vực quản lý</th>
                                    <th>{{areas.length}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in areas" :key="index">
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.id }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class=" rounded bg-white text-dark p-2 mt-4">
                        <table class="table-report w-100">
                            <thead>
                                <tr>
                                    <th>Số văn phòng quản lý</th>
                                    <th>{{branches.length}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in branches" :key="index">
                                    <td>{{ item.name_alias }}</td>
                                    <td>{{ item.id }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-xl-9 col-lg-8">
                    <div class=" rounded p-4">
                        <div class="d-lg-flex">
                            <div class="col-xl-6 col-lg-6 col-md-12 mb-3" style="height: 70px">
                                <h2>Kết quả Kinh doanh của khu vực</h2>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-12">
                                <h2>{{ regionName }}</h2>
                            </div>
                        </div>
                        <div class="table-config background-linear rounded text-white p-4 overflow-auto" style="">
                            <table class="table-report w-100 mt-4 table" >
                                <thead>
                                    <tr style="font-weight: bold">
                                        <th>Năm</th>
                                        <th>Quý</th>
                                        <th>Tổng doanh số</th>
                                        <th style="min-width: 150px">Tốc độ tăng trưởng</th>
                                        <th style="min-width: 150px">Tốc độ tăng trưởng công ty</th>
                                        <th style="min-width: 150px">Tốc độ tăng trưởng so với công ty</th>
                                    </tr>
                                </thead>
                                <tbody class="text-white">
                                <template v-for="(item, index) in region" >
                                    <tr v-if="item.year === now" :key="index">
                                        <td>{{ item.year }}</td>
                                        <td>{{ item.quarter }}</td>
                                        <td>{{ item.total_doanh_so | formatVND }}</td>
                                        <td :class="getClassCss(getGrowthRate(item))">{{ getGrowthRate(item) }} %</td>
                                        <td :class="getClassCss(getGrowthRateArea(item))">{{ getGrowthRateArea(item) }} %</td>
                                        <td :class="getClassCss(getGrowthRate(item) - getGrowthRateArea(item))">{{ (getGrowthRate(item) - getGrowthRateArea(item)).toFixed(2) }} %</td>
                                    </tr>
                                </template>

                                </tbody>
                            </table>
                        </div>
                        <div class="table-config background-linear p-4 rounded bg-white p-2 mt-4 overflow-auto">
                            <div class="row">
                                <div class="col-xl-5 col-lg-5 col-md-5" style="font-weight: bold">
                                    <h4 class="mt-1 mb-1" style="font-size: 20px; color: black!important;">Chọn khu vực</h4>
                                </div>
                                <div class="col-xl-5 col-lg-5 col-md-3">
                                    <el-select clearable v-model="query.areaId" filterable class="w-100"
                                            placeholder="Chọn khu vực" @change="changeArea">
                                        <el-option
                                            v-for="item in areas"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                            <span style="float: left">{{ item.name }}</span>
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <table class="table-report w-100 mt-4 table">
                                <thead>
                                    <tr style="font-weight: bold">
                                        <th>Khu vực</th>
                                        <th>Năm</th>
                                        <th>Quý</th>
                                        <th>Tổng doanh số</th>
                                        <th style="min-width: 150px">Tốc độ tăng trưởng công ty</th>
                                        <th style="min-width: 150px">Tốc độ tăng trưởng khu vực</th>
                                        <th style="min-width: 150px">Tốc độ tăng trưởng so với công ty</th>
                                    </tr>
                                </thead>
                                <tbody class="text-white">
                                    <tr v-for="(item, index) in quarterlyTotals" :key="index">
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.year }}</td>
                                        <td>{{ item.quarter }}</td>
                                        <td>{{ item.total_doanh_so | formatVND }}</td>
                                        <td :class="getClassCss(getGrowthRateArea(item))">{{ getGrowthRateArea(item) }} %</td>
                                        <td :class="getClassCss(getGrowthRate(item))">{{ getGrowthRate(item, true) }} %</td>
                                        <td :class="getClassCss(getGrowthRate(item, true) - getGrowthRateArea(item))">{{ (getGrowthRate(item, true) - getGrowthRateArea(item)).toFixed(2) }} %</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="table-config background-linear rounded p-4 mt-4 overflow-auto">
                            <table class="table-report w-100 text-left table">
                                <thead>
                                    <tr>
                                        <th>Khu vực</th>
                                        <th>Năm</th>
                                        <th>Tháng</th>
                                        <th>Chỉ tiêu Doanh số</th>
                                        <th>Tổng doanh số</th>
                                        <th>KPI Doanh số</th>
                                        <th>Lợi nhuận kinh doanh</th>
                                        <th>Số VP</th>
                                        <th>Doanh số trung bình/VP</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in monthlyTotals" :key="index">
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.year }}</td>
                                        <td>{{ item.month }}</td>
                                        <td>{{ item.total_target*0.9 | formatVND }}</td>
                                        <td>{{ item.total_doanh_so | formatVND }}</td>
                                        <td :class="getClassCss(getProfitKD(item))">{{ getProfitKD(item) }} %</td>
                                        <td>{{ item.total_loi_nhuan | formatVND }}</td>
                                        <td>{{ item.total_branch }}</td>
                                        <td>{{ item.total_doanh_so  / item.total_branch  | formatVND}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
            <div class=" col-12 table-config p-4 background-linear overflow-auto">
                <div class="row">
                    <div class="col-xl-3 col-lg-3 col-md-4" style="font-weight: bold">
                        <h4 style="font-size: 20px; color: black!important;">Chọn văn phòng</h4>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-4">
                        <el-select clearable v-model="query.branchId" filterable class="w-100"
                                placeholder="Chọn văn phòng" @change="changeBranches">
                            <el-option
                                v-for="item in branches"
                                :key="item.id"
                                :label="item.name_alias"
                                :value="item.id">
                                <span style="float: left">{{ item.name_alias }}</span>
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <table class="table-report w-100 text-left mt-4 table">
                    <thead>
                        <tr>
                            <th>Khu vực</th>
                            <th>Năm</th>
                            <th>Tháng</th>
                            <th style="min-width: 105px;">Văn phòng</th>
                            <th style="min-width: 175px;">Doanh số văn phòng</th>
                            <th style="min-width: 140px;">KPI Doanh số</th>
                            <th>Chi lương KD</th>
                            <th style="min-width: 80px;">Số SL</th>
                            <th style="min-width: 100px;">Tỷ lệ chốt</th>
                            <th style="min-width: 150px;">Số KH lên tư vấn</th>
                            <th style="min-width: 200px;">Lợi nhuận đội kinh doanh tại điểm</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in listBranch" :key="index">
                            <td >{{ item.area_name }}</td>
                            <td >{{ item.year }}</td>
                            <td >{{ item.month }}</td>
                            <td >{{ item.branch_name }}</td>
                            <td >{{ item.doanh_so | formatVND }}</td>
                            <td :class="getClassCss(getKpi(item))">{{ getKpi(item) }} %</td>
                            <td >{{ item.business_cost |formatVND }}</td>
                            <td>{{ item.sale_leader }}</td>
                            <td :class="getClassCss(getClosingRate(item))">{{ getClosingRate(item) }} %</td>
                            <td>{{ item.customers }}</td>
                            <td>{{ item.doanh_so - item.total_cost | formatVND }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</template>

<script>
import {
    REPORT_LIST_RSM,
    REPORT_RSM_TANG_TRUONG
} from "../../../core/services/store/report.module";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import lodash from "lodash-es";
import {mapGetters} from "vuex";

export default {
    // Tăng trưởng
    name: "Growth",
    data() {
        const currentYear = new Date().getFullYear();
        return {
            allArea: [],
            allBranches: [],
            revenueCompanyByQuarter: [],
            salesData: [],
            salesData1: [],
            now: new Date().getFullYear(),
            monthlyTotals: [],
            quarterlyTotals: [],
            quarterlyTotalsQuery: [],
            regionName: '',
            areas: [],
            branches: [],
            users: [],
            query: {
                userId: '',
                areaId: '',
                branchId: '',
            },
            region: [],
            disableSelectRsm: false,
            years: Array.from(
                { length: currentYear - 2023 },
                (_, i) => currentYear - i
            ),
            listBranch: [],
            disableSelectRsm: false
        }
    },
    created() {
        this.query.userId = this.currentUser?.id || ''
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Tăng trưởng", icon: 'far fa-sitemap'},
        ]);
        this.getUsers();
        this.getData();
        if (this.currentUser?.account_type?.name != 'BOD' || this.currentUser?.account_type?.id != 15) {
            this.disableSelectRsm = true;
        }
    },
    computed: {
        ...mapGetters(['currentUser'])
    },
    methods: {
        getData()
        {
            let payload = {
                year: this.now,
                user_id: this.query.userId
            };
            this.$store.dispatch(REPORT_RSM_TANG_TRUONG, payload).then((res) => {
                this.salesData = res.data.data_van_phong;
                this.revenueCompanyByQuarter = res.data.revenue_company_by_quarter;
                this.regionName = res.data.regions;
                this.areas = res.data.areas;
                this.branches = res.data.branches;
                this.handleDataRSM();
                this.query.areaId = '';
                this.query.branchId = '';
            });
        },
        handleDataRSM()
        {
            const regionQuarterlyTotals = {};
            this.salesData = this.salesData.map((item) => {
                const monthlyTotals = {};
                const quarterlyTotals = {};
                const name = item.name;
                const id = item.id;

                item.branches_active.map((branch) => {
                    const branchData = branch.data;
                    if (branchData) {

                        Object.values(branchData).forEach(entry => {
                            const month = entry.month;
                            const year = entry.year;
                            const loi_nhuan = entry.doanh_so - entry.total_cost;
                            const quarter = Math.ceil(month / 3); // Tháng 1–3 => Q1, 4–6 => Q2, etc.
                            const key = `Q${quarter}-${year}`;
                            const keyYearMonth = `${year}-${month}`

                            if (!monthlyTotals[keyYearMonth]) {
                                monthlyTotals[keyYearMonth] = {
                                    area_id: id,
                                    month,
                                    year,
                                    name,
                                    total_target: 0,
                                    total_doanh_so: 0,
                                    total_loi_nhuan: 0,
                                    total_branch: 0
                                };
                            }
                            monthlyTotals[keyYearMonth].total_target += Number(entry.target) || 0;
                            monthlyTotals[keyYearMonth].total_doanh_so += Number(entry.doanh_so) || 0;
                            monthlyTotals[keyYearMonth].total_loi_nhuan += Number(loi_nhuan) || 0;
                            monthlyTotals[keyYearMonth].total_branch ++;

                            // quý

                            if (!quarterlyTotals[key]) {
                                quarterlyTotals[key] = {
                                    quarter: quarter,
                                    year,
                                    name,
                                    id,
                                    total_target: 0,
                                    total_doanh_so: 0,
                                    total_loi_nhuan: 0,
                                    total_branch: 0
                                };
                            }

                            quarterlyTotals[key].total_target += Number(entry.target) || 0;
                            quarterlyTotals[key].total_doanh_so += Number(entry.doanh_so) || 0;
                            quarterlyTotals[key].total_loi_nhuan += Number(loi_nhuan) || 0;
                            quarterlyTotals[key].total_branch += 1;

                            entry.area_id = branch.area_id;
                            entry.area_name = name;
                            entry.branch_name = branch.name_alias;

                            return entry;
                        });
                    }
                    branch.area_name = name;
                    return branch;
                })
                item.monthlyTotals = lodash.orderBy(monthlyTotals, ['month'], ['desc']);
                item.quarterlyTotals = quarterlyTotals;

                if (quarterlyTotals) {
                    Object.entries(quarterlyTotals).forEach(([key, value]) => {
                        if (!regionQuarterlyTotals[key]) {
                            regionQuarterlyTotals[key] = {
                                quarter: value.quarter,
                                year: value.year,
                                key: key,
                                total_target: 0,
                                total_doanh_so: 0,
                                total_loi_nhuan: 0,
                                total_branch: 0
                            };
                        }

                        regionQuarterlyTotals[key].total_target += value.total_target;
                        regionQuarterlyTotals[key].total_doanh_so += value.total_doanh_so;
                        regionQuarterlyTotals[key].total_loi_nhuan += value.total_loi_nhuan;
                        regionQuarterlyTotals[key].total_branch += value.total_branch;
                    });
                }
                this.region = regionQuarterlyTotals;

                return item;
            });
            let dataAreas = Object.values(this.salesData).flatMap(item =>
                (item.branches_active || []).map(branch => {
                    const filteredData = Object.fromEntries(
                        Object.entries(branch.data || {}).filter(([_, entry]) => entry.year === this.now)
                    );

                    if (Object.keys(filteredData).length > 0) {
                        return {
                            ...branch,
                            data: filteredData
                        };
                    }
                    return null;
                }).filter(Boolean)
            );

            this.allBranches = dataAreas.length ? dataAreas : [];
            this.listBranch = dataAreas.length ? lodash.orderBy(dataAreas[0].data, ['month'], ['desc']) : [];

            if (this.salesData[0])
            {
                this.allArea = this.salesData[0];
                this.monthlyTotals = Object.values(this.allArea.monthlyTotals).filter(branch => branch.year === this.now);
                this.quarterlyTotals = Object.values(this.allArea.quarterlyTotals).filter(branch => branch.year === this.now);
                this.quarterlyTotalsQuery =  JSON.parse(JSON.stringify(Object.values(this.allArea.quarterlyTotals)));
            }
        },
        getGrowthRate(item, isArea=false)
        {
            let quarter = item.quarter - 1;
            let year = item.year;
            if (!quarter)
            {
                quarter = 4;
                year--;
            }
            let calculationData = this.salesData;
            if (isArea) {
                calculationData = this.salesData.filter(area => area.id == item.id);
            }
            let { total_doanh_so } = this.calculateQuarterTotals(calculationData, quarter, year);
            if (!total_doanh_so)
            {
                return 100;
            }
            let percent = total_doanh_so ? ((item.total_doanh_so - total_doanh_so) / total_doanh_so) * 100 : 0;
            return parseFloat(percent.toFixed(2));
        },
        calculateQuarterTotals(data, quarters, year) {
            let total_target = 0;
            let total_doanh_so = 0;
            let total_loi_nhuan = 0;

            data.forEach(area => {
                const quarterlyTotals = area.quarterlyTotals || {};
                Object.values(quarterlyTotals).forEach(quarter => {
                    if (quarter.year === year && quarter.quarter === quarters) {
                        total_target += quarter.total_target || 0;
                        total_doanh_so += quarter.total_doanh_so || 0;
                        total_loi_nhuan += quarter.total_loi_nhuan || 0;
                    }
                });
            });

            return {
                total_target,
                total_doanh_so,
                total_loi_nhuan
            };
        },
        getGrowthRateArea(item)
        {
            let quarter = item.quarter - 1;
            let year = item.year;
            if (!quarter)
            {
                quarter = 4;
                year--;
            }

            let totalAmountLastMonth = this.revenueCompanyByQuarter.find(item => item.quarter == quarter && item.year == year);
            let totalAmountCurrent = this.revenueCompanyByQuarter.find(total => total.quarter == item.quarter && total.year == item.year);

            if (!totalAmountLastMonth || !totalAmountCurrent)
            {
                return 0;
            }
            let percent = totalAmountLastMonth.amount_business_coefficient ? ((totalAmountCurrent.amount_business_coefficient - totalAmountLastMonth.amount_business_coefficient) / totalAmountLastMonth.amount_business_coefficient) * 100 : 0;

            return parseFloat(percent.toFixed(2));
        },
        formatPercent(value)
        {
            return Math.ceil(value);
        },
        getUsers()
        {
            this.$store.dispatch(REPORT_LIST_RSM, {}).then((res) => {
                this.users = res.data;
            });
        },
        changeArea()
        {
            this.allArea = this.salesData.filter(item => item.id === this.query.areaId);

            if (!this.allArea.length){
                return;
            }

            this.monthlyTotals = Object.values(this.allArea[0].monthlyTotals).filter(branch => branch.year === this.now);
            this.quarterlyTotals = Object.values(this.allArea[0].quarterlyTotals).filter(branch => branch.year === this.now);
        },
        changeBranches()
        {
            let data = Object.values(this.allBranches).filter(branch => {
                return branch.id === this.query.branchId;
            });
            this.listBranch = lodash.orderBy(data[0].data, ['month'], ['desc']);
        },
        getClassCss(value)
        {
            if(value > 0)
            {
                return 'text-success';
            }
            return 'text-danger'
        },
        getProfitKD(item)
        {
            return item.total_doanh_so ? Math.ceil((item.total_doanh_so / (item.total_target*0.9)) * 100) : 0;
        },
        getKpi(item)
        {
            return item.target ?  Math.ceil((item.doanh_so / item.target) * 100) : 0
        },
        getClosingRate(item)
        {
            return item.customers ? Math.ceil((item.new_contracts / item.customers) * 100) : 0
        }
    }
}
</script>

<style scoped>
    .bg-violet {
        background-color: rgb(47, 28, 74);
    }
    .table thead th {
        border-bottom: unset;
    }
    .table-config {
      background: linear-gradient(135deg, rgb(130, 48, 206) 0%, rgb(80, 54, 148) 100%);
      box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 2px 0px, rgba(0, 0, 0, 0.15) 0px 1px 3px 1px;
    }
    .custom-background {
        background: rgb(91 63 131)!important;
    }
    .background-linear {
        background: rgba(255, 255, 255, 0.9)!important;
        box-shadow:
            0 4px 6px rgba(139, 92, 246, 0.07),
            0 10px 15px rgba(139, 92, 246, 0.1),
            0 0 0 1px rgba(255, 255, 255, 0.05);
    }
    table thead {
        background: rgba(139, 92, 246, 0.05);
    }
    table tbody {
        background: white;
        color: black!important;
    }
    .table tbody tr:hover {
        background: rgba(102, 51, 153, 0.3);
    }
</style>
